import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowSelectorUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 15h14l-7-6z" })
});
export default SvgArrowSelectorUp;
